function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import ArrayFieldItem from './ArrayFieldItem';
import ArrayFieldSortable from './ArrayFieldSortable';
import { getUiOptions, retrieveSchema, toIdSchema } from "../utils";

class ArrayFieldNormal extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderItem", (item, index) => {
      const _this$props = this.props,
            id = _this$props.id,
            idPrefix = _this$props.idPrefix,
            formData = _this$props.formData,
            schema = _this$props.schema,
            uiSchema = _this$props.uiSchema,
            errorSchema = _this$props.errorSchema,
            registry = _this$props.registry,
            canRemove = _this$props.canRemove;
      const definitions = registry.definitions;
      const itemSchema = retrieveSchema(schema.items, definitions, item);
      const itemErrorSchema = errorSchema ? errorSchema[index] : undefined; //        const itemIdPrefix = idSchema.$id + "_" + index;

      const itemId = this.props.id + "_" + index;
      const itemIdSchema = toIdSchema(itemSchema, itemId, definitions, item, idPrefix);
      const itemUiSchema = uiSchema.items;
      const canMoveUp = index > 0;
      const canMoveDown = index < formData.length - 1;
      return React.createElement(ArrayFieldItem, _extends({}, this.props, {
        index: index,
        itemId: itemId,
        itemIdPrefix: itemId,
        canRemove: canRemove,
        canMoveUp: canMoveUp,
        canMoveDown: canMoveDown,
        itemSchema: itemSchema,
        itemUiSchema: itemUiSchema,
        itemIdSchema: itemIdSchema,
        itemErrorSchema: itemErrorSchema,
        itemData: item,
        key: index
      }));
    });
  }

  render() {
    const _this$props2 = this.props,
          registry = _this$props2.registry,
          uiSchema = _this$props2.uiSchema,
          canAdd = _this$props2.canAdd,
          onAddItem = _this$props2.onAddItem,
          onChange = _this$props2.onChange,
          items = _this$props2.items;
    const uiOptions = getUiOptions(uiSchema);

    if (uiOptions.sortable || uiOptions.draggable) {
      return React.createElement(ArrayFieldSortable, this.props);
    }

    const SchemaLayout = registry.fields.SchemaLayout;
    return React.createElement(SchemaLayout, _extends({}, this.props, {
      onAdd: canAdd && onAddItem,
      onChange: onChange
    }), items.length && items.map(this.renderItem));
  }

}

export default ArrayFieldNormal;